var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352 96C387.3 96 416 124.7 416 160V240H496C504.8 240 512 247.2 512 256C512 264.8 504.8 272 496 272H416V352C416 387.3 387.3 416 352 416H320C284.7 416 256 387.3 256 352V160C256 124.7 284.7 96 320 96H352zM352 128H320C302.3 128 288 142.3 288 160V352C288 369.7 302.3 384 320 384H352C369.7 384 384 369.7 384 352V160C384 142.3 369.7 128 352 128zM16 240H224V272H16C7.164 272 0 264.8 0 256C0 247.2 7.164 240 16 240z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.279b502f65618b20a431a90777defef9.svg";
export { ForwardRef as ReactComponent };